import React from 'react';
import {Box, Typography} from '@mui/material';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from 'common/names';
import {useTranslation} from 'react-i18next';
import HookFormRadioGroup from 'components/inputs/FormikRadioGroup';
import {enums} from 'types/enums';
import ExceptIPList from 'features/layout/DialogRoutes/dialogs/settings/AdvancedThreatIntelligence/ExceptIPList';
import {
   IIPAccessRulesSettings,
   IPAccessRulesSettings,
   IPAccessRulesSettingsNames,
} from 'types/diplomat/sftp/IPAccessRulesSettings';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {LookUpListButton} from './LookUpListDialog';

type Props = {
   onClose: (
      values?: IIPAccessRulesSettings,
      helpers?: FormOnSubmitHelpers<IIPAccessRulesSettings>
   ) => void;
   data?: {
      values?: IIPAccessRulesSettings;
      text?: string;
      submitLabel?: string;
      isAdmin?: boolean;
   };
};

const BLOCK_STYLE = {height: '30rem'};

const IPAccessRulesDialog = ({onClose, data}: Props) => {
   const {t} = useTranslation();

   const handleSave = (
      values: IIPAccessRulesSettings,
      helpers: FormOnSubmitHelpers<IIPAccessRulesSettings>
   ) => {
      // send allowList and denyList to server here
      onClose(values, helpers);
   };

   return (
      <DialogComponent maxWidth="md" header={DialogTypes.IPAccessRules.dialogName} close={onClose}>
         <Typography sx={{mb: 2}}>
            {data?.text ||
               `IP Access Restrictions allow you to control which IP addresses are allowed to connect to
the Diplomat MFT SFTP Server. Choose to allow or deny certain IPs. Allow takes
precedence over deny.`}
         </Typography>
         <Formik
            initialValues={IPAccessRulesSettings.cast(data?.values || {})}
            onSubmit={handleSave}
            enableReinitialize
         >
            <div style={BLOCK_STYLE}>
               <HookFormRadioGroup
                  name={IPAccessRulesSettingsNames.defaultBehavior}
                  label={t('Diplomat MFT Connection Access Control')}
                  options={enums.acessControlBehavior.options}
                  row
               />
               {!data?.isAdmin && (
                  <Box sx={{ml: '5rem', mt: '2rem', display: 'inline-block'}}>
                     <LookUpListButton />
                  </Box>
               )}
               <ExceptIPList />
               {!data?.isAdmin && (
                  <Box sx={{padding: '1rem 3rem'}}>
                     <Typography variant="body2">
                        {t(
                           '* When the default behavior is DENY, the exception list will automatically include all User allowed IPs, and all exceptions to VFS Group IP Access Rules set to DENY.'
                        )}
                     </Typography>
                  </Box>
               )}
            </div>

            <FormFooterButtons cancel={onClose} submitLabel={data?.submitLabel || 'Save'} />
         </Formik>
      </DialogComponent>
   );
};

export default IPAccessRulesDialog;
